import { ShippingType } from 'features/orders/models/ShippingType';
import {
    MappingShippingRate,
    ShippingRateMapping,
} from 'features/shipping-provider/settings/models/shipping-rate-mapping';
import { useGetCountryName } from 'hooks/ppoints/useGetCountryName';
import { MappedShippingTypeGroupRates } from './MappedShippingTypeGroupRates';

const HOME_DELIVERY_LABEL_KEY = 'MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.MODAL.HOME_DELIVERY_RATES_TITLE';
const PICKUP_POINT_LABEL_KEY = 'MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.MODAL.PICKUP_POINT_RATES_TITLE';

/** Every non-home-delivery type carries the same rate set for a country, so duplicates from
 * merging them into one "Pickup Points" group are collapsed by rate id. */
const dedupeRatesById = (rates: MappingShippingRate[]): MappingShippingRate[] => [
    ...new Map(rates.map((rate) => [rate.id, rate])).values(),
];

export const MappedCountryRatesSection: React.FC<{ mapping: ShippingRateMapping }> = ({ mapping }) => {
    const { getTranslatedCountryName } = useGetCountryName();

    const homeDeliveryProviderRates = mapping.providerRates.filter(
        (providerRate) => providerRate.shippingType === ShippingType.HOME_DELIVERY
    );
    const pickupPointProviderRates = mapping.providerRates.filter(
        (providerRate) => providerRate.shippingType !== ShippingType.HOME_DELIVERY
    );

    return (
        <div className="flex flex-col gap-2 p-3 rounded-lg border border-border">
            <div className="flex items-center gap-1">
                <s-icon type="globe-europe" />
                <s-text type="strong">{getTranslatedCountryName(mapping.country?.countryCode ?? '')}</s-text>
            </div>
            <div className="flex flex-col gap-1">
                {pickupPointProviderRates.length > 0 && (
                    <MappedShippingTypeGroupRates
                        labelKey={PICKUP_POINT_LABEL_KEY}
                        shippingRates={dedupeRatesById(
                            pickupPointProviderRates.flatMap((providerRate) => providerRate.shippingRates)
                        )}
                    />
                )}
                {homeDeliveryProviderRates.length > 0 && (
                    <MappedShippingTypeGroupRates
                        labelKey={HOME_DELIVERY_LABEL_KEY}
                        shippingRates={dedupeRatesById(
                            homeDeliveryProviderRates.flatMap((providerRate) => providerRate.shippingRates)
                        )}
                    />
                )}
            </div>
        </div>
    );
};

export default MappedCountryRatesSection;
